import React from 'react';
import './Loader.css';

const Loader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="full-page-loader">
      <div className="loader-container">
        {/* Main Logo/Text */}
        <div className="loader-brand">
          <div className="loader-logo">
                    <img
          src="https://images.vastrebyvijh.com/vastre-images/monogram/desktop/2025-08-26/monogram_desktop_1756240573600_0_1080w.webp"
          alt="Vastré Monogram"
          className="monogram-image"
          onError={(e) => {
            e.target.src = '/images/monogram/monogram_desktop_1756135549612_0_1080w.webp';
          }}
        />
          </div>
          <h1 className="loader-title">Vastré</h1>
          <p className="loader-subtitle">Crafting Excellence</p>
        </div>
        
        {/* Animated Loading Bar */}
        <div className="loader-progress">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
          <div className="progress-text">Loading...</div>
        </div>
        
        {/* Floating Elements */}
        <div className="loader-elements">
          <div className="floating-element element-1">✨</div>
          <div className="floating-element element-2">👔</div>
          <div className="floating-element element-3">🎩</div>
          <div className="floating-element element-4">👕</div>
        </div>
        
        {/* Bottom Decorative Line */}
        <div className="loader-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-dot"></div>
          <div className="decoration-line"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
